import React, { useCallback, useEffect, useState } from 'react'

import { string } from 'prop-types'

import Search from 'Pods/NewHomepage/Components/Search/Search'
import i18n from 'Pods/Shared/I18n'
import PrintModels from 'Pods/Shared/Icons/PrintModels'

import useBreakpoint from 'Utils/useBreakpoint'

import { Fallback } from './3D/Fallback'
import { ViewerProvider, useViewerReducer } from './context/ViewerProvider'

// No webpackPrefetch: its runtime calls document.head.appendChild() during SSR bundle
// evaluation, which forced a global `document` stub that in turn made
// @floating-ui/react-dom's `typeof document !== 'undefined'` guard pick the real
// useLayoutEffect on the server (SSR warning on every Triangle UI Dropdown).
const loadUserModal = () => import('./3D/Viewer').then((module) => module.Viewer)

let Viewer = null

function NewPrintModelsHero({ locale }) {
  const [isLoadedViewerComponent, setIsLoadedViewerComponent] = useState(false)
  const [state, dispatch] = useViewerReducer()
  const breakpoint = useBreakpoint()

  const openUserModal = useCallback(async () => {
    if (Viewer) return

    const module = await loadUserModal()
    Viewer = module

    setIsLoadedViewerComponent(true)
  }, [])

  useEffect(() => {
    if (breakpoint === 'xs') {
      return
    }

    const userActivityEvents = ['click', 'scroll', 'keydown', 'touchstart', 'mousemove']
    let hasTriggered = false

    const handleUserActivity = () => {
      if (!hasTriggered) {
        hasTriggered = true
        openUserModal()
        userActivityEvents.forEach((event) => {
          document.removeEventListener(event, handleUserActivity, { passive: true })
        })
      }
    }

    userActivityEvents.forEach((event) => {
      document.addEventListener(event, handleUserActivity, { passive: true })
    })

    return () => {
      userActivityEvents.forEach((event) => {
        document.removeEventListener(event, handleUserActivity, { passive: true })
      })
    }
  }, [openUserModal])

  const sectionTitle = i18n.t('printModelPage.sectionTitle', { ns: 'rails', lng: locale })
  const heroTitle = i18n.t('printModelPage.heroTitle', { ns: 'rails', lng: locale })
  const sectionDescription = i18n.t('printModelPage.sectionDescription', { ns: 'rails', lng: locale })
  const placeholderText = i18n.t('printModelPage.placeholderText', { ns: 'rails', lng: locale })

  return (
    <section className="print-models-hero">
      <div className="print-models-hero__content">
        <div className="print-models-hero__badge">
          <PrintModels width="24" height="24" className="print-models-hero__badge-icon" />
          <span>{sectionTitle}</span>
        </div>
        <div className="print-models-hero__text">
          <h1 className="print-models-hero__title">{heroTitle}</h1>
          <span className="print-models-hero__description">
            {sectionDescription}
          </span>
        </div>
        <Search printReady placeholder={placeholderText} />
      </div>
      <div className="print-models-hero__image-wrapper">
        <div className="print-models-hero__image">
          {(!isLoadedViewerComponent || (isLoadedViewerComponent && Viewer && !state.isLoad)) && <Fallback />}
          {isLoadedViewerComponent && Viewer && (
            <ViewerProvider reducer={[state, dispatch]}>
              <Viewer />
            </ViewerProvider>
          )}
        </div>
      </div>
    </section>
  )
}

NewPrintModelsHero.propTypes = {
  locale: string.isRequired,
}

export default NewPrintModelsHero
